<template>
  <div class="dialog-alert">
    <div class="content-modal">
      <h2>{{title}}</h2>
      <p v-for="linha in text" :key="linha.index">{{linha}}</p>
      <div class="btn-dialog">
        <button class="btn-cancelar-dialog"
          @click="$emit('update:modelValue', false);
          $emit('close')">
          Cancelar
        </button>
        <button @click="$emit('update:modelValue', true);
          $emit('close')">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogModal',
  emits: [
    'update:modelValue',
    'close'
  ],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: String,
    text: Array
  },
  data () {
    return {
    }
  }

}
</script>

<style lang="scss">
  .dialog-alert {
    position: fixed;
    z-index: 999;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(53, 53, 53, 0.5);
    display: grid;
    transition: opacity 0.3s ease;
    overflow-y: initial !important;
    align-content: center;
  }

  .dialog-alert:target {
    opacity: 1;
    pointer-events: auto;
  }

  .content-modal {
    width: 70%;
    position: relative;
    background-color: #ffffff;
    transition: opacity 3s ease !important;
    align-content: center;
    left: 15%;

    .btn-dialog {
      display: inline-block;
    }

    .btn-cancelar-dialog {
      background-color: #ffffff00;
      color: #C2171A;
    }

    button {
      width: auto;
    }

  }
</style>
